<div class="document-viewer-container">
    <!-- Loading state -->
    <div *ngIf="isLoading" class="flex justify-center items-center h-full">
      <div class="flex flex-col items-center">
        <p-progressSpinner styleClass="w-10 h-10"></p-progressSpinner>
        <p class="mt-4 text-gray-600">Chargement du document...</p>
      </div>
    </div>
  
    <!-- Error state -->
    <div *ngIf="error" class="flex flex-col items-center justify-center w-full h-64 text-center p-5">
      <div class="text-red-500 mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      <h3 class="text-lg font-medium text-gray-800 mb-2">Erreur de chargement</h3>
      <p class="text-gray-600 mb-4">{{ error }}</p>
      <button pButton icon="pi pi-times" label="Fermer" class="p-button-secondary p-button-sm" (click)="closeDialog()"></button>
    </div>
  
    <!-- Document display -->
    <div *ngIf="!isLoading && !error" class="document-content">
      <div  class="flex justify-between items-center pb-5 mb-5 border-b border-gray-200">
        <h3 class="text-lg font-medium text-gray-800 truncate max-w-lg">{{ fileName }}</h3>
        <div class="flex gap-2">
          <button 
            pButton 
            icon="pi pi-download" 
            class="p-button-text p-button-sm !border-none" 
            title="Télécharger"
            (click)="!isLoadingDownloadDocument && downloadDocument()">
          </button>
          <button 
            pButton 
            icon="pi pi-times" 
            class="p-button-text p-button-sm rounded-full w-9 h-9 !border-none" 
            title="Fermer"
            (click)="!isLoadingDownloadDocument && closeDialog()">
          </button>
        </div>
      </div>
  
      <!-- PDF viewer with fallback -->
      <div *ngIf="isPdf" class="h-full w-full relative">
        <!-- PDF Loading Indicator -->
        <div *ngIf="pdfLoading" class="absolute inset-0 flex items-center justify-center bg-gray-50 bg-opacity-75 z-10">
          <div class="flex flex-col items-center">
            <p-progressSpinner styleClass="w-8 h-8"></p-progressSpinner>
            <p class="mt-2 text-gray-600">Chargement du PDF...</p>
          </div>
        </div>
        
        <!-- PDF iframe - Added #pdfContainer reference -->
        <div #pdfContainer class="w-full h-full">
          <iframe 
            *ngIf="fileUrl"
            [src]="fileUrl" 
            class="w-full h-[calc(100vh-211px)]" 
            frameborder="0"
            (load)="onPdfLoad()"
            (error)="onPdfError()"
            title="Visionneuse PDF">
          </iframe>
        </div>
        
        <!-- Fallback download option (shown if iframe has issues) -->
        <div *ngIf="pdfLoading === false && !fileUrl" class="h-full w-full flex flex-col items-center justify-center p-4">
          <i class="pi pi-file-pdf text-6xl text-red-500 mb-4"></i>
          <h3 class="text-lg font-medium text-gray-800 mb-2">{{ fileName }}</h3>
          <p class="text-gray-600 mb-4">Le PDF ne peut pas être affiché directement.</p>
          <button pButton icon="pi pi-download" label="Télécharger le PDF" (click)="!isLoadingDownloadDocument && downloadDocument()"></button>
        </div>
      </div>
  
      <!-- Image viewer -->
      <div *ngIf="isImage" class="h-full w-full flex items-center justify-center overflow-auto">
        <img 
          *ngIf="fileUrl"
          [src]="fileUrl" 
          class="max-w-full max-h-full object-contain w-full h-[calc(100vh-211px)]" 
          [alt]="fileName" 
          (error)="onImageError()" />
      </div>
  
      <!-- Office documents (Word, Excel, etc.) -->
      <div *ngIf="isOfficeDocument" class="h-full w-full">
        <div class="flex flex-col items-center justify-center h-64 p-5">
          <div *ngIf="fileExtension === 'doc' || fileExtension === 'docx'" class="text-primary mb-4">
            <i class="pi pi-file-word text-6xl"></i>
          </div>
          <div *ngIf="fileExtension === 'xls' || fileExtension === 'xlsx'" class="text-primary mb-4">
            <i class="pi pi-file-excel text-6xl"></i>
          </div>
          <div *ngIf="fileExtension === 'ppt' || fileExtension === 'pptx'" class="text-primary mb-4">
            <i class="pi pi-file text-6xl"></i>
          </div>
          <div *ngIf="!['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(fileExtension)" class="text-primary mb-4">
            <i class="pi pi-file text-6xl"></i>
          </div>
          
          <h3 class="text-lg font-medium text-gray-800 mb-2">{{ fileName }}</h3>
          <p class="text-gray-600 mb-4">Ce type de document ne peut pas être affiché directement.</p>
          <button pButton icon="pi pi-download" label="Télécharger" (click)="!isLoadingDownloadDocument && downloadDocument()"></button>
        </div>
      </div>
  
      <!-- Other file types -->
      <div *ngIf="!isPdf && !isImage && !isOfficeDocument" class="h-full w-full">
        <div class="flex flex-col items-center justify-center h-64 p-5">
          <i class="pi pi-file text-6xl text-gray-500 mb-4"></i>
          <h3 class="text-lg font-medium text-gray-800 mb-2">{{ fileName }}</h3>
          <p class="text-gray-600 mb-4">Ce type de fichier ne peut pas être affiché directement.</p>
          <button pButton icon="pi pi-download" label="Télécharger" (click)="!isLoadingDownloadDocument && downloadDocument()"></button>
        </div>
      </div>
      
      <!-- Download error message -->
      <div *ngIf="downloadError" class="fixed bottom-0 left-0 right-0 bg-red-100 text-red-800 p-3 text-center">
        Impossible de télécharger le fichier. Veuillez réessayer.
        <button pButton icon="pi pi-times" class="p-button-text p-button-sm ml-2" (click)="downloadError = false"></button>
      </div>
    </div>
  </div>